module.exports = __webpack_public_path__ + "static/media/a78ec8a1-4b55-463a-877c-28c6dcc51481.4d0e4514.JPG";